var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    fill: "none",
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5CC862",
    d: "M5.788 14.176.252 8.048l1.552-1.504 3.952 4.352L14.332.768l1.632 1.456L5.788 14.176Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPositive);
export default __webpack_public_path__ + "static/media/icon_positive.1e8acc62517f930f5967c16708b7e057.svg";
export { ForwardRef as ReactComponent };